import React, { useEffect, useState } from 'react';
import './prloader.css';
import as from '../../asserts/as.png'
const Loader = () => {
    const [visible, setVisible] = useState(true);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setHide(true);
            setTimeout(() => {
                setVisible(false);
            }, 700);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <div className={`loader ${hide ? 'loader--hide' : ''}`}>
            <div className="loader__scene">
                <div className="loader__square loader__square--outer"></div>
                <div className="loader__square loader__square--middle">

                </div>
                <img className="loader__square loader__square--inner" src={as} alt="Loading design ornament" />
            </div>
            <p className="loader__text">LOADING</p>
        </div>
    );
};

export default Loader;